export default {
    // Header Section
    "discover_your": "Discover Your",
    "life_predictions": "Life Predictions",
    "future_unveiled_through_stars": "Future Unveiled Through Stars",
    "life_predictions_description": "Get comprehensive life predictions based on Vedic astrology and planetary analysis. Understand your future milestones, major life events, career growth, marriage timing, wealth accumulation, and spiritual journey with precise astrological insights.",

    // Service Information
    "enter_details_for_predictions": "Enter Your Details for Life Predictions",
    "complete_life_predictions": "Complete Life Predictions",
    "service_price": "Service Price",
    "comprehensive_life_predictions_note": "Detailed analysis of your future life events and astrological guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_destiny_influence": "Your name vibrations shape your destiny and future opportunities",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_future_insights": "Essential for calculating planetary periods and future predictions",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_predictions": "Precise time needed for accurate dasha calculations and predictions",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_essential_for_predictions": "Location affects planetary positions influencing future events",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your life predictions will be delivered in the selected language",

    // Core Prediction Features
    "future_life_events_predictions": "Future Life Events Predictions",
    "career_success_timeline": "Career Success Timeline",
    "marriage_relationship_predictions": "Marriage & Relationship Predictions",
    "wealth_prosperity_forecast": "Wealth & Prosperity Forecast",
    "health_longevity_insights": "Health & Longevity Insights",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Life Predictions Include",
    "comprehensive_future_roadmap": "Comprehensive Future Roadmap",
    "major_life_events_timeline": "Major Life Events Timeline",
    "planetary_influence_analysis": "Planetary Influence Analysis",
    "remedial_guidance_solutions": "Remedial Guidance & Solutions",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Life Predictions",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Predictions",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "life_predictions_processing": "Your life predictions are being prepared by our expert Vedic astrologers. You'll receive detailed insights into your future life events and cosmic timeline.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_24_hours_delivery_note": "Your detailed life predictions will be ready within 24 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete predictions delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Life Predictions Package",
    "detailed_life_predictions": "Comprehensive Life Predictions Report (PDF)",
    "future_events_timeline": "Future Events Timeline & Dates",
    "career_marriage_wealth_predictions": "Career, Marriage & Wealth Predictions",
    "planetary_periods_analysis": "Planetary Periods (Dasha) Analysis",
    "remedial_solutions_guidance": "Remedial Solutions & Guidance",

    // Visual Content
    "sample_life_predictions": "Sample Life Predictions",
    "major_life_milestone": "Major Life Milestone",
    "sample_prediction_reading": "Career breakthrough and marriage prospects in the next 2-3 years",
    "sample_predictions_preview": "Preview of your personalized life predictions with timeline insights",
    "life_prediction_areas": "Life Prediction Areas",

    // Life Area Types
    "career": "Career",
    "marriage": "Marriage",
    "wealth": "Wealth",
    "family": "Family",
    "health": "Health",
    "education": "Education",

    // Status & Processing
    "your_predictions_status": "Your Life Predictions Status",
    "processing_your_predictions": "Analyzing Your Future",
    "predictions_processing_message": "Our Vedic astrology experts are calculating your planetary periods and analyzing future events based on your birth chart.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_24_hours": "Report ready within 24 hours",

    // Support & Contact
    "contact_support": "Contact Astrology Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Predictions processing failed. Contact our support team.",

    // Prediction-Specific Elements
    "planetary_periods": "Planetary Periods (Dashas)",
    "mahadasha": "Mahadasha Periods",
    "antardasha": "Antardasha Sub-periods",
    "pratyantar_dasha": "Pratyantar Dasha",
    "transit_analysis": "Planetary Transits",
    "yogas_combinations": "Auspicious Yogas & Combinations",

    // Life Events Predictions
    "career_milestones": "Career Milestones",
    "job_changes": "Job Changes & Promotions",
    "business_opportunities": "Business Opportunities",
    "educational_achievements": "Educational Achievements",
    "marriage_timing": "Marriage Timing",
    "childbirth_predictions": "Childbirth Predictions",
    "property_acquisition": "Property & Real Estate",
    "travel_opportunities": "Travel & Foreign Opportunities",

    // Career Predictions
    "professional_growth": "Professional Growth Timeline",
    "success_periods": "Success & Recognition Periods",
    "career_challenges": "Career Challenge Periods",
    "leadership_roles": "Leadership Opportunities",
    "business_ventures": "Business Venture Success",
    "financial_growth": "Financial Growth Patterns",

    // Marriage & Relationships
    "love_life_predictions": "Love Life Predictions",
    "marriage_compatibility": "Marriage Partner Compatibility",
    "relationship_timing": "Relationship Milestones",
    "family_expansion": "Family Growth & Children",
    "marital_harmony": "Marital Harmony Periods",
    "relationship_challenges": "Relationship Challenge Periods",

    // Wealth & Finance
    "wealth_accumulation": "Wealth Accumulation Timeline",
    "investment_success": "Investment Success Periods",
    "property_gains": "Property & Asset Gains",
    "business_profits": "Business Profit Cycles",
    "financial_setbacks": "Financial Challenge Periods",
    "debt_recovery": "Debt Recovery & Financial Stability",

    // Health & Longevity
    "health_timeline": "Health Timeline Predictions",
    "disease_periods": "Health Challenge Periods",
    "recovery_periods": "Recovery & Healing Periods",
    "longevity_analysis": "Longevity & Life Span Analysis",
    "accident_prone_periods": "Accident Prone Periods",
    "vitality_enhancement": "Vitality Enhancement Periods",

    // Family & Social
    "family_events": "Family Events & Milestones",
    "children_predictions": "Children-Related Predictions",
    "parental_health": "Parents' Health & Well-being",
    "sibling_relationships": "Sibling Relationships",
    "social_recognition": "Social Status & Recognition",
    "community_involvement": "Community Leadership Roles",

    // Spiritual & Personal Growth
    "spiritual_awakening": "Spiritual Awakening Periods",
    "religious_inclinations": "Religious & Spiritual Inclinations",
    "pilgrimage_opportunities": "Pilgrimage & Sacred Journeys",
    "meditation_periods": "Meditation & Inner Growth",
    "guru_connections": "Spiritual Teacher Connections",
    "moksha_path": "Liberation & Enlightenment Path",

    // Timing & Cycles
    "auspicious_periods": "Auspicious Time Periods",
    "challenging_periods": "Challenging Time Periods",
    "neutral_periods": "Neutral & Stable Periods",
    "transformation_phases": "Major Transformation Phases",
    "opportunity_windows": "Opportunity Windows",
    "decision_making_periods": "Optimal Decision Making Times",

    // Age-Based Predictions
    "childhood_predictions": "Childhood & Early Life",
    "teenage_predictions": "Teenage & Youth Predictions",
    "young_adult_phase": "Young Adult Phase (20-35)",
    "middle_age_predictions": "Middle Age Predictions (35-55)",
    "senior_years": "Senior Years & Retirement",
    "life_completion": "Life Completion & Legacy",

    // Remedies & Solutions
    "planetary_remedies": "Planetary Remedies",
    "gemstone_recommendations": "Gemstone Recommendations",
    "mantra_chanting": "Beneficial Mantras",
    "charity_suggestions": "Charitable Activities",
    "ritual_recommendations": "Ritual & Puja Recommendations",
    "lifestyle_modifications": "Lifestyle Modifications",

    // Advanced Predictions
    "karma_analysis": "Karmic Pattern Analysis",
    "past_life_influences": "Past Life Influences",
    "soul_purpose": "Soul Purpose & Mission",
    "destiny_fulfillment": "Destiny Fulfillment Path",
    "life_lessons": "Key Life Lessons",
    "evolutionary_growth": "Evolutionary Soul Growth",

    // Specific Event Timing
    "marriage_age_prediction": "Marriage Age Prediction",
    "first_child_timing": "First Child Timing",
    "career_peak_period": "Career Peak Period",
    "maximum_wealth_phase": "Maximum Wealth Phase",
    "health_recovery_timing": "Health Recovery Timing",
    "spiritual_realization": "Spiritual Realization Phase",

    // Global & Environmental
    "foreign_opportunities": "Foreign Travel & Opportunities",
    "relocation_predictions": "Relocation & Migration",
    "global_connections": "International Connections",
    "cultural_exchanges": "Cultural & Educational Exchanges",
    "technology_adaptations": "Technology & Innovation Involvement",

    // Detailed Time Frames
    "next_year_predictions": "Next Year Predictions",
    "next_5_years": "Next 5 Years Overview",
    "next_10_years": "Next Decade Forecast",
    "life_phases": "Major Life Phases",
    "cyclical_patterns": "Recurring Life Patterns",
    "milestone_achievements": "Major Milestone Achievements"
};
